module.exports = "img/photo24.99cf84.jpeg";